import { SubmitgyanService } from './../../core/services/submit-gyan/submitgyan.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, ChangeDetectorRef, SimpleChange, SimpleChanges, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CreateGyanService } from 'src/app/core/services/create-gyan/create-gyan.service';
import { MessageService } from 'src/app/core/web-socket/message.service';
import { ClickbackService } from 'src/app/core/services/clickback/clickback.service';
import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { CommonServiceService } from './../../core/services/common-service/common-service.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ClickOutsideDirective } from 'src/app/directives/clickoutside.directive';
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { ArticleService } from './../../core/services/articles/article.service';
import { Packer } from 'docx';
import { saveAs } from 'file-saver';
import { DocumentCreator } from '../export/doc-generator';
import { CustomDocumentCreator } from '../export/doc-generator-custom';
import { PDFDocumentCreator } from '../export/pdf-generator';
import { NetworkService } from 'src/app/core/services/NetworkService/NetworkService.service';

@Component({
    selector: 'app-multi-doc-summary-section',
    templateUrl: './multi-doc-summary-section.component.html',
    styleUrls: ['./multi-doc-summary-section.component.scss'],
})
export class MultiDocSummarySectionComponent {
    loading: boolean = true;
    multidocsummary: any;
    @Input() PreviousGyanId: any;
    @Input() gyanStatusfromSocket: any;
    @Output() clickbackdata = new EventEmitter<string>();
    @Output() clickbackparaids = new EventEmitter<string>();
    @ViewChild('optionsBox') optionsBox!: ElementRef;

    gyanStatus: any;
    callwebsocket: any;
    // socketSubscription: Subscription;
    currentGyanId: any;
    selectedPara: any;
    gyanTitle: string = '';
    summaryNotAvailable = false;
    isClickable: any;
    isMobile: boolean = false;
    loaderMessage = 'Loading Summary';
    isRapid = true;
    gyanrunning = false;
    gyanfailed = false;

    private previousGyanClicked: Subscription;
    private previousGyanOnload: Subscription;
    private createGyanInitiated: Subscription;
    private callfromSocketForMDS: Subscription;
    private SelectedId: Subscription;
    sentenceIds: any;
    isChatGPTSummary = false;
    showtooltip: boolean = false;
    // chatGptSummary :string =  "A Gyan Summary could not be produced for this topic.This is a retrieval augmented summary generated by GPT 4.Gyan's traceability or click-back to sentences in source content is not available in GPT or other LLM generated output."
    chatGptSummary: string =
        'There wasn’t sufficient relevant content for Gyan to generate a synopsis. This summary was generated from ChatGPT, click back to source documents is not available.';
    displayTooltip = false;
    faAngleDown = faAngleDown;
    faAngleRight = faAngleRight;
    rapidGyan = true; // make this false when advanced gyan is called
    contextualSummary: any;
    summaryDetail: any;
    // trueSummaries:any;
    // falseSummaries:any
    knowledgedStoreSummeries: any;
    articalSummeries: any;
    isSentenceClickable = true;
    selectedParaId: any;
    gyanType: any;
    topicType: any;
    headerDisplayParams: any;
    showPKSPermission: boolean = false;

    topicId: any;
    gyanVersion = '';
    topicOutline: any;
    allTopicArticles: any = [];
    topicLevelMultidocSummary: any = [];
    articleChatGPTSummary: any = [];
    topicImagesList: any = [];
    topicLevelConfig: any = [];
    topicLevelConfigOrg: any = [];
    topicLevelConfigRequests: any = [];
    articleListRequests: any = [];
    articleMultiListRequests: any = [];
    articleChatGPTListRequests: any = [];
    topicImagesListRequests: any = [];
    sortKey = '';
    sortValue = '';
    menuOpen = false;
    showExportBtn = false;
    private globalClickListener!: () => void;
    private callTopicHierarchyEvent: Subscription;

    toast: any;
    isOnline: boolean = true;

    constructor(
        private translateService: TranslateService,
        private creategyanservice: CreateGyanService,
        private messageService: MessageService,
        private clickbackservice: ClickbackService,
        private localStorageService: LocalStorageService,
        private commonServiceService: CommonServiceService,
        private toastrService: ToastrService,
        private cd: ChangeDetectorRef,
        private submitgyanservice: SubmitgyanService,
        private authservice: AuthService,
        private articleService: ArticleService,
        private renderer: Renderer2,
        private networkService: NetworkService,
    ) {
        const userLang = navigator.language || 'en';
        const lanuageCode = userLang.split('-')[0];
        this.translateService.setDefaultLang(lanuageCode);
        this.translateService.use(lanuageCode);

        this.networkService.status$.subscribe((status) => {
            console.log('MultiDocSummarySectionComponent.networkService.status', status);
            this.isOnline = status;
            if (status === false) {
                this.toastrService.clear(this.toast.toastId);
            }
        });

        // calling subject to load mds by taking gyan id from localstorage on previous gyan click
        this.previousGyanClicked = this.commonServiceService.previousGyanClick$.subscribe((value) => {
            console.log('the value of the calltype is', value);
            const gyanData = this.localStorageService.getItem('gyanData');
            this.gyanStatus = gyanData.gyanStatus;
            this.topicType = value.callType;
            this.checkAccessList();
            if (value.callMDS) {
                console.log('the sub previousGyanClick', value);
                console.log('this.loading >>> 97');

                this.loading = true;
                this.displayTooltip = false;
                const gyanData = this.localStorageService.getItem('gyanData');
                if (gyanData.gyanCreatedNow == 'yes') {
                    //this  is just displayed for the first time when the user initiates a gyan
                    this.loaderMessage = 'Compiling Summary';
                } else {
                    this.loaderMessage = 'Loading Summary';
                }
                this.summaryNotAvailable = false;
                this.isChatGPTSummary = false;
                this.gyanTitle = gyanData.gyanName;
                if (gyanData.gyanType === 'rapid') {
                    this.isRapid = true;
                    setTimeout(() => {
                        this.getMDSSummary(gyanData.gyanId);
                    }, 1000);
                    this.rapidGyan = true;
                }
                if (gyanData.gyanType === 'gyan') {
                    this.isRapid = false;
                    this.selectedParaId = '';
                    this.rapidGyan = false;
                    this.currentGyanId = gyanData.gyanId;
                    this.callMDSforAdvancedQueries(gyanData.gyanId);
                }
            }
        });

        // calling subject to load mds by taking gyan id from localstorage on previous gyan onLoad
        this.previousGyanOnload = this.commonServiceService.previousGyanOnload$.subscribe((value) => {
            if (value) {
                this.checkAccessList();
                console.log('the sub previousGyanOnload', value);
                const gyanData = this.localStorageService.getItem('gyanData');
                this.gyanStatus = gyanData.gyanStatus;
                console.log(gyanData);
                console.log('this.loading >>> 135');

                this.loading = true;
                this.displayTooltip = false;
                this.isChatGPTSummary = false;
                this.loaderMessage = 'Loading Summary';
                this.gyanTitle = gyanData.gyanName;
                if (gyanData.gyanType === 'rapid') {
                    this.isRapid = true;
                    setTimeout(() => {
                        this.getMDSSummary(gyanData.gyanId);
                    }, 1000);
                    this.rapidGyan = true;
                }
                if (gyanData.gyanType === 'gyan') {
                    this.isRapid = false;
                    this.selectedParaId = '';
                    this.callMDSforAdvancedQueries(gyanData.gyanId);
                    this.rapidGyan = false;
                    this.currentGyanId = gyanData.gyanId;
                }
            }
        });

        // calling subject to load articles by taking gyan id from localstorage
        this.createGyanInitiated = this.commonServiceService.createGyanInitiated$.subscribe((value) => {
            if (value) {
                this.checkAccessList();
                console.log('the sub createGyanInitiated', value);
                const gyanData = this.localStorageService.getItem('gyanData');
                console.log(gyanData);
                this.gyanStatus = gyanData.gyanStatus;
                console.log('this.loading >>> 167');

                this.loading = true;
                this.displayTooltip = false;
                this.isChatGPTSummary = false;
                this.loaderMessage = 'Compiling Summary';
                this.gyanTitle = gyanData.gyanName;
                this.summaryNotAvailable = false;
                if (gyanData.gyanType == 'gyan') {
                    this.gyanrunning = true;
                    this.loadingIcon();
                }
                // this.getMDSSummary(gyanData.gyanId);
                // setTimeout(() => {
                //     this.checkSocketMessage();
                // }, 10);
            }
        });

        // calling this function from socket page
        this.callfromSocketForMDS = this.commonServiceService.callfromSocketForMDS$.subscribe((value) => {
            if (value) {
                console.log('the sub callfromSocketForMDS', value);
                //this.loading = true;
                console.log('getting call from Socket');
                const gyanData = this.localStorageService.getItem('gyanData');
                this.gyanStatus = gyanData.gyanStatus;
                // this.loaderMessage = 'Compiling Summary';

                if (gyanData.gyanType === 'rapid') {
                    this.isRapid = true;
                    this.getMDSSummary(gyanData.gyanId);
                    this.rapidGyan = true;
                }
                if (gyanData.gyanType === 'gyan') {
                    this.isRapid = false;
                    this.callMDSforAdvancedQueries(gyanData.gyanId);
                    this.rapidGyan = false;
                    this.currentGyanId = gyanData.gyanId;
                }
            }
        });

        //this is to higlight the selected sentence of MDS when we come back from longstory page to MDS(if we have navigated through clickback)
        this.SelectedId = this.commonServiceService.SelectedId$.subscribe((value) => {
            console.log('the sub SelectedId', value);
            if (value) {
                this.displayTooltip = false;
                console.log('the value is', value);
                this.selectedPara = this.commonServiceService.paraIdselected;
                this.selectedParaId = this.commonServiceService.paraIdselected;
            } else {
                console.log('the value is deselected');
                this.selectedPara = '';
                this.selectedParaId = '';
            }
        });

        this.callTopicHierarchyEvent = this.articleService.callTopicHierarchyEvent$.subscribe((topicOutline) => {
            console.log('ngOnInit.callTopicHierarchyEvent.ngOnInit.topicOutline', topicOutline);
            this.topicOutline = topicOutline;
        });
    }
    checkAccessList() {
        if (this.authservice.isSignInUser()) {
            this.showPKSPermission = this.authservice.getAccessList('ShowPKS');
        }
    }

    ngOnInit() {
        this.checkWidth();
        this.commonServiceService.paraIdselected = '';
        const gyanData = this.localStorageService.getItem('gyanData');
        this.gyanType = gyanData.gyanType;

        this.globalClickListener = this.renderer.listen('document', 'click', (clickEvent: MouseEvent) => {
            if (this.menuOpen) {
                this.menuOpen = false;
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['gyanStatusfromSocket']) {
            console.log('the change detected', changes['gyanStatusfromSocket']['currentValue']);
            const gyanStatus = changes['gyanStatusfromSocket']['currentValue'];
            this.gyanStatus = gyanStatus;
            if (gyanStatus == 'FINISHED') {
                this.gyanrunning = false;
                this.gyanfailed = false;
            }
            if (gyanStatus == 'FAIL') {
                this.gyanrunning = false;
                this.gyanfailed = true;
            }
            if ((gyanStatus != 'FINISHED' && gyanStatus != 'FAIL' && gyanStatus != 'NO_ARTICLE_IN_SEARCH') || gyanStatus != '9') {
                this.gyanrunning = true;
                this.gyanfailed = false;
            }
            if (gyanStatus == 'NO_ARTICLE_IN_SEARCH') {
                this.gyanrunning = false;
                this.gyanfailed = false;
                console.log('this.loading >>> 258');

                this.loading = true;
                this.summaryNotAvailable = true;
            }

            const gyanDataLocal = this.localStorageService.getItem('gyanData'); // this line added because it is calling function and converting default subject value to new values.
            const gyanData = {
                gyanName: gyanDataLocal.gyanName,
                gyanId: gyanDataLocal.gyanId,
                gyanType: gyanDataLocal.gyanType,
                gyanCreatedNow: gyanDataLocal.gyanCreatedNow,
                clickbackfromgyan: gyanDataLocal.clickbackfromgyan,
                gyanStatus: gyanStatus,
            };
            this.localStorageService.setItem('gyanData', gyanData);
        }
    }

    callMDSforAdvancedQueries(topicId: any) {
        console.log('callMDSforAdvancedQueries.api called');
        const topicID = topicId;
        this.submitgyanservice.getMDSforAdvancedQueries(topicID).subscribe({
            next: (response: any) => {
                console.log('callMDSforAdvancedQueries.response of advanced mds', response);
                const gyanData = this.localStorageService.getItem('gyanData');
                console.log('callMDSforAdvancedQueries.gyanData', gyanData);
                this.headerDisplayParams = response.contextualSummary;
                console.log('the this.headerDisplayParams are', this.headerDisplayParams);
                //gyans that are called from left panel list AQ
                // if (gyanData.gyanCreatedNow == 'no') {
                this.gyanStatus = gyanData.gyanStatus;
                if (gyanData.gyanStatus == 'FINISHED' || gyanData.gyanStatus == 'FAIL' || gyanData.gyanStatus == '9' || gyanData.gyanStatus == 'NO_ARTICLE_IN_SEARCH') {
                    this.checkTheMDSLoadingStatus(response, true);
                } else {
                    this.checkTheMDSLoadingStatus(response, false);
                }
                this.loadingIcon();
                // } else if (gyanData.gyanCreatedNow == 'yes') {
                //gyans that are newly create from submit gyan form
                // this.checkTheMDSLoadingStatus(response, true);
                // this.loadingIcon();
                // }
                this.addIsExpandedFieldInSummary(this.summaryDetail);
                this.addIsExpandedFieldInSummary(this.knowledgedStoreSummeries);
                this.addIsExpandedFieldInSummary(this.articalSummeries);
            },
            error: (error: HttpErrorResponse) => {
                console.log('Error: ', error.message);
            },
            complete: () => {
                setTimeout(() => {
                    const gyanData = this.localStorageService.getItem('gyanData');
                    const obj = {
                        callMDS: false,
                        callArticles: false,
                        callType: gyanData.callType === 'topic' ? true : false,
                    };
                    this.commonServiceService.setPreviousGyanClick(obj);
                }, 1000);
            },
        });
    }
    loadingIcon() {
        //conditions to display the icon

        const gyanData = this.localStorageService.getItem('gyanData');
        this.gyanStatus = gyanData.gyanStatus;
        if (gyanData.gyanStatus == 'FAIL') {
            this.gyanrunning = false;
            this.gyanfailed = true;
        } else if (gyanData.gyanStatus == 'FINISHED' || gyanData.gyanStatus == 'NO_ARTICLE_IN_SEARCH' || gyanData.gyanStatus == '9') {
            this.gyanrunning = false;
            this.gyanfailed = false;
        } else {
            if (!this.topicType) {
                console.log('the status is', gyanData.gyanStatus);
                this.gyanrunning = true;
                this.gyanfailed = false;
            }
        }
    }

    checkTheMDSLoadingStatus(response: any, loadstatus: any) {
        console.log('checkTheMDSLoadingStatus.loadstatus', loadstatus, response);
        //below condition is added to display either or both of the summaries(PKS and othersource)
        if (response.contextualSummary.hasPKSSource || response.contextualSummary.hasOtherSources) {
            const gyanData = this.localStorageService.getItem('gyanData');
            this.gyanStatus = gyanData.gyanStatus;
            this.summaryDetail = response.contextualSummary.summary;
            // Separate true and false summaries
            this.knowledgedStoreSummeries = response.contextualSummary.summary.filter((item: any) => item.isKnetSummaryPara === true);
            this.articalSummeries = response.contextualSummary.summary.filter((item: any) => item.isKnetSummaryPara === false);
            //stop the loader only if the gyan is finished/failed/noarticles
            if (gyanData.gyanStatus == 'FINISHED' || gyanData.gyanStatus == 'FAIL' || gyanData.gyanStatus == '9' || gyanData.gyanStatus == 'NO_ARTICLE_IN_SEARCH') {
                console.log('this.loading >>> 347');
                this.loading = false;
            } else {
                //Below condition is to load mds based on the Notification getting (calling mds api and loading latest data)
                if (response.contextualSummary.hasOtherSources || response.contextualSummary.hasPKSSource) this.loading = false;
                else {
                    console.log('this.loading >>> 353');
                    this.loading = true;
                }
            }
            this.isSentenceClickable = response.contextualSummary.isSentenceClickable;
            this.contextualSummary = response;
        } else {
            //removed below condition for GA-2904
            // if (this.topicType) {
            //     console.log("coming inside here - topictype if")
            //     this.loading = true;
            //     this.summaryNotAvailable = true;
            // } else {
            this.checkforAllFalsePKSandOthers(response);
            // if (!response.contextualSummary.hasPKSSource && !response.contextualSummary.hasOtherSources) {
            //     this.loading = false;
            // } else {
            //     this.loading = true;
            // }
            // this.summaryNotAvailable = loadstatus;
            // }
            this.cd.detectChanges();
        }
    }

    checkforAllFalsePKSandOthers(response: any) {
        const gyanData = this.localStorageService.getItem('gyanData');

        //GA-3201 fix
        if (!response.contextualSummary.hasPKSSource && !response.contextualSummary.hasOtherSources) {
            if (gyanData.gyanStatus == 'FINISHED' || gyanData.gyanStatus == 'FAIL' || gyanData.gyanStatus == '9' || gyanData.gyanStatus == 'NO_ARTICLE_IN_SEARCH') {
                this.loading = true;
                this.summaryNotAvailable = true;
            } else {
                this.summaryNotAvailable = false;
                this.loading = true;
            }
        }
    }

    addIsExpandedFieldInSummary(summary: any) {
        if (this.summaryDetail) {
            this.summaryDetail.forEach((summary: any) => {
                if (summary) {
                    summary['isExpanded'] = false;
                    if (summary.nextLevel) {
                        this.addIsExpandedFieldInSummary(summary.children);
                    }
                }
            });
        } else if (this.knowledgedStoreSummeries) {
            this.knowledgedStoreSummeries.forEach((summary: any) => {
                if (summary) {
                    summary['isExpanded'] = false;
                    if (summary.nextLevel) {
                        this.addIsExpandedFieldInSummary(summary.children);
                    }
                }
            });
        } else if (this.articalSummeries) {
            this.articalSummeries.forEach((summary: any) => {
                if (summary) {
                    summary['isExpanded'] = false;
                    if (summary.nextLevel) {
                        this.addIsExpandedFieldInSummary(summary.children);
                    }
                }
            });
        }
    }

    expandCollapseIconClicked(summaryItem: any) {
        summaryItem.isExpanded = !summaryItem.isExpanded;
    }

    // checkSocketMessage() {
    //     console.log('checkSocketMessage');
    //     const gyanData = this.localStorageService.getItem('gyanData');
    //     this.messageService.stompClient.subscribe('/message', (message: any) => {
    //         console.log(message);
    //         const msgBody = JSON.parse(message.body);
    //       //  if (gyanData) {
    //             if (msgBody.dt === 3 && msgBody.id === gyanData.gyanId) this.getMDSSummary(msgBody.id);
    //       //  } else {
    //       //      if (msgBody.dt === 3) this.getMDSSummary(msgBody.id);
    //       //  }
    //     });
    // }

    getMDSSummary(gyanId: any) {
        console.log('function called');
        this.currentGyanId = gyanId;
        this.creategyanservice.callMDS(gyanId).subscribe({
            next: (response: HttpResponse<any>) => {
                console.log('Status code:', response.status);
                console.log(response);
                if (response.status == 200) {
                    const responseBody = response.body;
                    this.multidocsummary = responseBody.data.paragraphs;
                    this.isChatGPTSummary = responseBody.data.isChatGPTSummary;
                    this.isClickable = responseBody.data.clickable;
                    console.log('this.loading >>> 438');

                    this.loading = false;
                    console.log('this.multidocsummary', this.multidocsummary);
                } else if (response.status == 204) {
                    console.log('this.loading >>> 444');

                    this.loading = true;
                    this.summaryNotAvailable = true;
                }
            },
            error: (error: HttpErrorResponse) => {
                console.log('Error: ', error.message);
                // this.toastrService.error('Unable to submit your search. Please try again later');
                if (error.error.statusCode == 422) {
                    console.log('the gyan is deleted');
                }
                // When the gyan is not submitted, go back to the dashboard home
                this.commonServiceService.gotoDashboard.next(!this.isMobile);
            },
            complete: () => {
                console.log('MDS got successfully');
            },
        });
    }

    selectPara(selectedPara: any, sentenceIds: any) {
        console.log('selectPara called');
        if (selectedPara === this.selectedPara) {
            console.log('same para selected');
            const gyanData = { gyanName: this.gyanTitle, gyanId: this.currentGyanId, gyanType: 'rapid', gyanCreatedNow: 'no', clickbackfromgyan: 'No' };
            // revert back the article lists
            this.commonServiceService.paraIdselected = '';
            this.commonServiceService.setSelectedId(this.commonServiceService.paraIdselected);
            this.commonServiceService.setResetArticleList(true);
            this.selectedPara = this.commonServiceService.paraIdselected;
            this.sentenceIds = [];
            this.clickbackparaids.emit(this.sentenceIds);
            this.cd.detectChanges();
        } else {
            console.log('para selected', selectedPara);
            const gyanData = { gyanName: this.gyanTitle, gyanId: this.currentGyanId, gyanType: 'rapid', gyanCreatedNow: 'no', clickbackfromgyan: 'No' };
            this.localStorageService.setItem('gyanData', gyanData);
            //making these socketcall false since it is been called from message service directly for a clickback
            this.commonServiceService.setCallfromSocketArticleList(false);
            this.commonServiceService.setCallfromSocketArticleListSummary(false);
            // this.commonServiceService.setCreateGyanInitiated(false);

            this.clickbackservice.clickback(this.currentGyanId, selectedPara).subscribe({
                next: (response: any) => {
                    if (response.code === 200) {
                        console.log('clickback data', response);
                        const obj = {
                            callMDS: false,
                            callArticles: false,
                        };
                        this.commonServiceService.setPreviousGyanClick(obj);
                        this.clickbackdata.emit(response);
                    }
                },
                error: (error: HttpErrorResponse) => {
                    console.log('Error: ', error.message);
                },
            });
            this.commonServiceService.paraIdselected = selectedPara;
            this.selectedPara = selectedPara;
            this.commonServiceService.paraIdselected = this.selectedPara;
            this.sentenceIds = sentenceIds;
            this.clickbackparaids.emit(this.sentenceIds);
        }
    }

    clickback(selectedPara: any) {
        console.log('clickback called');
        if (selectedPara === this.selectedParaId) {
            console.log('double clicking');
            const gyanData = { gyanName: this.gyanTitle, gyanId: this.currentGyanId, gyanType: 'gyan', gyanCreatedNow: 'no', clickbackfromgyan: 'No' };
            this.localStorageService.setItem('gyanData', gyanData);
            this.commonServiceService.paraIdselected = '';
            this.commonServiceService.setSelectedId(this.commonServiceService.paraIdselected);
            this.commonServiceService.setResetArticleList(true); //load the getbooknode summary API again
        } else {
            const gyanlocal = this.localStorageService.getItem('gyanData');
            const type = 'CONTEXTUAL';
            this.commonServiceService.setCallfromSocketArticleList(false);
            this.commonServiceService.setCallfromSocketArticleListSummary(false);
            this.submitgyanservice.getClickbackData(gyanlocal.gyanId, selectedPara, type).subscribe({
                next: (response: any) => {
                    const gyanData = { gyanName: this.gyanTitle, gyanId: this.currentGyanId, gyanType: 'gyan', gyanCreatedNow: 'no', clickbackfromgyan: 'yes' };
                    this.localStorageService.setItem('gyanData', gyanData);
                    console.log('clickback data', response);
                    const obj = {
                        callMDS: false,
                        callArticles: false,
                    };
                    this.commonServiceService.setPreviousGyanClick(obj);
                    this.clickbackdata.emit(response);
                },
                error: (error: HttpErrorResponse) => {
                    console.log('Error: ', error.message);
                },
                complete: () => {
                    this.commonServiceService.setResetArticleList(false);
                },
            });
            this.commonServiceService.paraIdselected = selectedPara;
            this.selectedParaId = selectedPara;
            this.commonServiceService.paraIdselected = this.selectedParaId;
        }
    }

    ngOnDestroy() {
        this.previousGyanClicked.unsubscribe();
        this.previousGyanOnload.unsubscribe();
        // this.createGyanInitiated.unsubscribe();
        this.callfromSocketForMDS.unsubscribe();
        this.SelectedId.unsubscribe();
        if (this.globalClickListener) {
            this.globalClickListener();
        }
    }

    checkWidth() {
        const width = window.innerWidth;
        //console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    showTooltipFunction(value: boolean) {
        this.showtooltip = value;
        console.log('calling the tooltip func and checking', this.showtooltip);
    }

    displaytooltipMobile() {
        this.displayTooltip = !this.displayTooltip;
    }

    hideTooltip() {
        console.log('clicked outside');
        this.displayTooltip = false;
    }

    checkGyanStatus() {
        if (this.gyanStatus == 'FINISHED' || this.gyanStatus == 'FAIL' || this.gyanStatus == 'NO_ARTICLE_IN_SEARCH' || this.gyanStatus == '9') {
            return 1;
        } else {
            return 0;
        }
    }

    async gotoExport(docType: string) {
        console.log('gotoExport');
        this.toast = this.toastrService.info('Preparing data...', '', { disableTimeOut: true });
        //this.closeExportModal();
        this.allTopicArticles = [];
        this.topicLevelMultidocSummary = [];
        this.topicLevelConfig = [];
        //this.disableButton = true;
        const totalSearchArticles = this.getArticleCount(this.topicOutline, 0, false);
        const totalRelevantArticles = this.getArticleCount(this.topicOutline, 0, true);

        console.log('allTopicIds.topicOutline', this.topicOutline);
        //await this.getTopicLevelMultidocSummary(this.topicId);
        const allTopicIds = await this.getAllTopicIds(this.topicOutline);

        console.log('allTopicIds', allTopicIds);

        const topicConfigs = {
            topicIds: allTopicIds,
        };

        await this.getTopicLevelConfig(topicConfigs, this.topicId);
        //await this.getTopicLevelMultidocSummary(this.topicId);

        const gyanSummary = {
            gyanTitle: this.topicOutline.text,
            rootTopic: this.topicOutline,
            topics: this.topicOutline.children ? this.topicOutline.children : [],
            totalSearchArticles,
            totalRelevantArticles,
        };
        await this.iterateTopicsForArticles(this.topicOutline, []);

        let allPromises = [...this.articleListRequests, ...this.articleMultiListRequests];

        if (this.topicLevelConfig && this.topicLevelConfig.length) {
            allPromises = [
                ...this.articleListRequests,
                ...this.articleMultiListRequests,
                ...this.articleChatGPTListRequests,
                ...this.topicImagesListRequests,
                ...this.topicLevelConfigRequests,
            ];
        }

        if (docType === 'word') {
            await Promise.all(allPromises).then((data) => {
                setTimeout(async () => {
                    const documentCreator = new DocumentCreator();
                    const customDocumentCreator = new CustomDocumentCreator();
                    let doc: any = null;
                    let fileName = this.topicOutline.text;
                    let isConfigObjEmpty = true;
                    if (this.topicLevelConfig && this.topicLevelConfig.length) {
                        isConfigObjEmpty = await this.checkConfigObject(this.topicLevelConfig[0], this.topicId);
                    }
                    console.log('isConfigObjEmpty', isConfigObjEmpty);
                    //const custom = this.topicLevelConfig.length > 0 ? true : false;
                    if (!isConfigObjEmpty) {
                        doc = await customDocumentCreator.create([
                            gyanSummary,
                            this.allTopicArticles,
                            this.topicLevelMultidocSummary,
                            this.topicLevelConfigOrg,
                            this.articleChatGPTSummary,
                            this.topicImagesList,
                        ]);
                        const todayDate = await this.getCurrentDateMMDDYYYY();
                        fileName = `${this.topicOutline.text} Diligence Insights ${todayDate}`;
                    } else {
                        doc = documentCreator.create([gyanSummary, this.allTopicArticles, this.topicLevelMultidocSummary]);
                    }
                    console.log('fileName', fileName);
                    this.toastrService.clear(this.toast.toastId);
                    Packer.toBlob(doc).then((blob) => {
                        saveAs(blob, fileName + '.docx');
                    });
                }, 1000);
            });
        } else if (docType === 'pdf') {
            await Promise.all(allPromises).then((data) => {
                setTimeout(() => {
                    const documentCreator = new PDFDocumentCreator();
                    const doc = documentCreator.create([gyanSummary, this.allTopicArticles, this.topicLevelMultidocSummary]);
                    this.toastrService.clear(this.toast.toastId);
                    doc.save(this.topicOutline.text + '.pdf');
                }, 1000);
            });
        }
        this.toastrService.clear(this.toast.toastId);
        //this.setDisableButton();
    }

    getArticleCount(topic: any, total: any, countTypeRel: boolean) {
        if (countTypeRel) {
            total += topic.relevantArticle;
        } else {
            total += topic.searchArticle;
        }
        if (topic.children) {
            topic.children.map((childTopic: any) => {
                total = this.getArticleCount(childTopic, total, countTypeRel);
            });
        }
        return total;
    }

    async getAllTopicIds(data: any) {
        const ids = new Set();

        // Add the current item's ID
        ids.add(data.id);

        if (data.children && data.children.length > 0) {
            // Iterate over each child and collect IDs recursively
            for (const child of data.children) {
                ids.add(child.id); // Add the current child's ID
                const childIds = await this.getAllTopicIds(child); // Recursively collect IDs from the child's children
                childIds.forEach((id) => ids.add(id)); // Add each child ID to the Set
            }
        }

        return Array.from(ids); // Convert Set back to array before returning
    }

    getTopicLevelConfig(reqBody: any, topicId: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.articleService.getTopicLevelConfig(reqBody).subscribe(
                (res) => {
                    this.topicLevelConfig.push(res);
                    this.topicLevelConfigOrg.push({ ...res });
                    resolve(true);
                },
                (err: any) => {
                    resolve(false);
                },
            );
        });
    }

    async iterateTopicsForArticles(topic: any, arr: any) {
        this.articleListRequests.push(this.getTopicArticles(topic));
        this.articleMultiListRequests.push(this.getTopicLevelMultidocSummary(topic.id));
        if (this.topicLevelConfig && this.topicLevelConfig.length) {
            const topicLevelConfig = this.topicLevelConfig[0][topic.id];

            // if (topicLevelConfig && topicLevelConfig.gptSummary == 'ON_TOP') {
            this.articleChatGPTListRequests.push(this.getTopicLevelChatGPTSummary(topic.id, topicLevelConfig));
            //}
            this.topicImagesListRequests.push(this.getUserDocuments(topic.id));
        }
        //this.topicLevelConfigRequests.push(this.getTopicLevelConfig(topic.id));
        if (topic.children) {
            topic.children.map(async (childitem: any) => {
                await this.iterateTopicsForArticles(childitem, arr);
            });
        }
    }

    async checkConfigObject(configObj: any, topicId: number): Promise<boolean> {
        // Delete the property corresponding to the topicId
        delete configObj[topicId];

        console.log('isConfigObjEmpty.configObj', configObj);

        // Check if the object is empty or if all its remaining properties are empty objects
        return Object.keys(configObj).every((key) => {
            const value = configObj[key];
            return typeof value === 'object' && value !== null && Object.keys(value).length === 0;
        });
    }

    async getCurrentDateMMDDYYYY() {
        const today = new Date();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(today.getDate()).padStart(2, '0');
        const year = today.getFullYear();

        return month + day + year;
    }

    getTopicArticles(topic: any): Promise<any> {
        return new Promise((resolve, reject) => {
            const params = this.getUrlsParams(topic.id);
            //this.articleService.getbooknodesummary({ topicId: topic.id, pageNumber: 1, getAllArticles: true }).subscribe(
            this.articleService.getbooknodesummary(params).subscribe(
                (res: any) => {
                    this.allTopicArticles.push(res);
                    resolve(true);
                },
                () => {
                    //this.setDisableButton();
                },
            );
        });
    }

    getTopicLevelMultidocSummary(topicId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.articleService.getTopicLevelMultidocSummary(topicId).subscribe(
                (res: any) => {
                    const obj = {
                        topicId: topicId,
                        paragraphs: [res],
                    };
                    this.topicLevelMultidocSummary.push(obj);
                    resolve(true);
                },
                (err: any) => {
                    //this.disableButton = false;
                    //this.cd.detectChanges();
                    resolve(false);
                },
            );
        });
    }

    getTopicLevelChatGPTSummary(topicId: number, topicLevelConfig: any): Promise<any> {
        return new Promise((resolve, reject) => {
            if (topicLevelConfig && topicLevelConfig.gptSummary == 'ON_TOP') {
                this.articleService.getTopicLevelGPT3Summary(topicId).subscribe(
                    (res: any) => {
                        const obj = {
                            topicId: topicId,
                            paragraphs: [res.summary],
                        };
                        this.articleChatGPTSummary.push(obj);
                        resolve(true);
                    },
                    // eslint-disable-next-line sonarjs/no-identical-functions
                    (err: any) => {
                        //this.disableButton = false;
                        //this.cd.detectChanges();
                        resolve(false);
                    },
                );
            } else {
                resolve(true);
            }
        });
    }

    private getUserDocuments(topicId: number) {
        return new Promise((resolve, reject) => {
            this.articleService.getUserDocuments(topicId).subscribe(async (response: any) => {
                if (response != undefined && response != null && response != '' && response['attachments'].length > 0) {
                    const base64Images = await this.convertAttachmentsToBase64(response.attachments);
                    console.log('getUserDocuments.base64Images', base64Images);
                    const obj = {
                        topicId: topicId,
                        paragraphs: base64Images,
                    };
                    this.topicImagesList.push(obj);
                    //this.topicImagesList.push(response.attachments);
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        });
    }

    async convertAttachmentsToBase64(imagesList: any): Promise<Array<any>> {
        console.log('convertAttachmentsToBase64.imagesList', imagesList);
        const promises = imagesList.map(async (attachment: any) => {
            return await this.convertImageToBase64(attachment.u);
        });

        return Promise.all(promises);
    }

    async convertImageToBase64(imgURL: string): Promise<{ base64: string; width: number; height: number }> {
        const response = await this.articleService.getImageFromUrl(imgURL).toPromise();

        let base64Data = await this.convertBlobToBase64(response);

        base64Data = base64Data.replace('data:application/octet-stream;base64', 'data:image/jpeg;base64');

        // Get the dimensions of the image
        const dimensions = await this.getImageDimensions(base64Data);

        console.log(`Image Dimensions: Width = ${dimensions.width}, Height = ${dimensions.height}`);

        return { base64: base64Data, width: dimensions.width, height: dimensions.height };
    }

    convertBlobToBase64(blob: any): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result as string);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    async getImageDimensions(base64Image: string): Promise<{ width: number; height: number }> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                resolve({ width: img.width, height: img.height });
            };
            img.onerror = reject;
            img.src = base64Image;
        });
    }

    getUrlsParams(topicId: any) {
        console.log('----- getUrlsParams ----');
        const params: any = {};
        params.getAllArticles = true;
        params.topicId = topicId;
        params.pageNumber = 1;
        //params.sortBy = [{ key: 'relevance', value: 1 }];
        params.sortBy = [{ key: this.sortKey, value: this.sortValue }];
        //params.filterOn = [{ key: '' }];
        return params;
    }

    onButtonClick(event: MouseEvent) {
        event.stopImmediatePropagation();
        this.menuOpen = !this.menuOpen;
    }
}
